import { login, getInfo } from '@/api/login'
import router, { resetRouter } from '@/router'
import md5 from 'js-md5';
import { AesEncode, AesDecode } from '../../utils/encryptAes'
import { isPC } from "@/utils/browser";
import {Message} from "element-ui";


const state = {
    dataOne: null, // 景区销售排名的数据
}
const mutations = {
    SET_BI_ONE(state, val) {
        state.dataOne = val
    },
}

export default {
    namespaced: true,
    state,
    mutations,
}